import { render, staticRenderFns } from "./GameBagCanvasComponent.vue?vue&type=template&id=b13c57d2&"
import script from "./GameBagCanvasComponent.vue?vue&type=script&lang=ts&"
export * from "./GameBagCanvasComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports